const state = {
  appSelectionId: false,
  datacenterVersion: null
};

const getters = {
  getAppSelectionId: state => {
    return state.appSelectionId;
  },
  getDatacenterVersion: state => {
    return state.datacenterVersion;
  }
};

const mutations = {
  setAppSelectionId: (state, payload) => {
    state.appSelectionId = payload;
  },
  setDatacenterVersion: (state, payload) => {
    state.datacenterVersion = payload;
  }
};

const actions = {
  setAppSelectionId: ({ commit }, payload) => {
    commit("setAppSelectionId", payload);
  },
  setDatacenterVersion: ({ commit }, payload) => {
    commit("setDatacenterVersion", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
